import { Campaign } from '../interfaces/entities/campaign'

export const campaigns: Campaign[] = [
  { id: '1', name: 'Kampanjen Luf Svicen', projectNumber: 'P123' },
  { id: '2', name: 'Kampanjen Luf Muf', projectNumber: 'P456' },
  { id: '3', name: 'Kampanjen Manjen', projectNumber: 'P789' },
  { id: '4', name: 'Kampanjennzi biten', projectNumber: 'P987' },
  { id: '5', name: 'Kampanjenzi kommen', projectNumber: 'P654' },

  {
    id: '11584',
    name: 'Die süßesten Süßigkeiten',
  },
]
